import { CompanyUserEditPage } from "@/features/company/pages/company-user/CompanyUserEdit";

const CompanyUserEdit = () => {
  return <CompanyUserEditPage />;
};

export default CompanyUserEdit;
